import { mapGetters, mapMutations } from 'vuex';

export default {
  data() {
    return {
      webChatsObserver: null
    };
  },
  beforeMount() {
    this.webChatsObserver = new MutationObserver(this.webChatMutationObserverCallback);
  },
  mounted() {
    const observerConfig = { childList: true, subtree: true };
    this.webChatsObserver.observe(document.body, observerConfig);
  },
  beforeDestroy() {
    this.webChatsObserver.disconnect();
  },
  computed: {
    ...mapGetters({
      webChatLoaded: 'general/webChatLoaded',
      partnerDataHrb: 'hrbPartner/partnerData',
      partnerDataDashboard: 'profile/dashboard/partnerData'
    }),
    webChatScript() {
      switch (this.$i18n.locale) {
        case 'cs':
          return import.meta.env.MODE === 'production'
            ? '/daktela-web-chat-prod.js'
            : '/daktela-web-chat-beta.js';
        default:
          return import.meta.env.MODE === 'production'
            ? `/daktela-web-chat-prod-${this.$i18n.locale}.js`
            : `/daktela-web-chat-beta-${this.$i18n.locale}.js`;
      }
    },
    partnerData() {
      return this.partnerDataDashboard ?? this.partnerDataHrb;
    }
  },
  methods: {
    webChatMutationObserverCallback(mutationList) {
      if (
        mutationList.findIndex(mt =>
          Array.from(mt.addedNodes)
            .map(an => an.id)
            .includes('daktela-web')
        ) > -1
      ) {
        if (this.$route.meta.layout === 'ProfileLayout') {
          const elements = document.querySelectorAll(
            '#daktela-web .dw-button, #daktela-web .dw-body'
          );
          elements.forEach(element => {
            if (!element.classList.contains('profile')) {
              element.classList.add('profile');
            }
          });
        }
        this.webChatScriptLoaded();
      }
    },
    showWebChat() {
      if (['cs', 'en', 'hu', 'sk'].includes(this.$i18n.locale)) {
        if (this.webChatLoaded) {
          document.querySelector('#daktela-web').style.display = 'block';
          this.webChatScriptLoaded();
        } else {
          const script = document.createElement('script');
          script.async = true;
          script.type = 'text/javascript';
          script.src = this.webChatScript;
          script.id = 'daktelaWebchatLoader';

          document.head.appendChild(script);
        }
      }
    },
    ...mapMutations({
      setWebChatLoaded: 'general/setWebChatLoaded'
    }),
    bindWebchatClose() {
      const webchatHeaderControl = document.querySelector('[data-component-name="webHeadControl"]');
      const webHeadHide = document.querySelector('#daktela-web-header-hide');
      const mainButton = document.querySelector('[data-component-name="mainButton"]');

      webHeadHide.addEventListener('click', () => mainButton.click(), { capture: true });

      webchatHeaderControl.addEventListener('click', event => {
        if (event.target.id !== 'daktela-web-header-close') {
          mainButton.click();
        }
      });
    },
    webChatScriptLoaded() {
      this.setWebChatLoaded(true);
      this.bindWebchatClose();
    }
  }
};
